import React from 'react';
import LemkinAIWebsite from './LemkinAIWebsite';

function App() {
  return <LemkinAIWebsite />;
}

export default App;